<template>
    <FormBox header="Angaben zum Verlag">
        <div class="row" v-show="currentType != PublicationType.Zeitschriftenaufsatz">
            <div class="col-12 col-lg-8">
                <!-- Create new Verlag: name field (the Erscheinungsort sits next to it) -->
                <template v-if="form._publisherCreateNew">
                    <div class="form-highlight mb-3">
                        <label class="form-label-alt">
                            <span>Neuer Verlag</span>
                        </label>
                        <div class="d-flex gap-2 align-items-start">
                            <input
                                v-model="form._publisherName"
                                type="text"
                                class="form-control"
                                placeholder="Verlagsname"
                                :required="currentType != PublicationType.Zeitschriftenaufsatz"
                            >
                            <button
                                type="button"
                                class="lfmpub-select__cancel"
                                @click="cancelCreate"
                                title="Abbrechen"
                            ><i class="fa-thin fa-arrow-rotate-left"></i></button>
                        </div>
                    </div>
                </template>

                <!-- Normal select with "create new" option -->
                <template v-else>
                    <FormSelect
                        v-model="form.publisher"
                        :options="payload.publishers"
                        option-value="uid"
                        option-label="name"
                        label="Verlag"
                        tooltip="publisher"
                        placeholder="Verlag auswählen"
                        :highlight="true"
                    >
                        <template #before-options>
                            <div
                                class="lfmpub-select__option lfmpub-select__option--create-entity"
                                @click="startCreate"
                            >
                                <i class="fa-thin fa-plus me-1"></i> Neuen Verlag anlegen
                            </div>
                        </template>
                    </FormSelect>
                </template>
            </div>
            <div class="col-12 col-lg-4">
                <!-- The Erscheinungsort is stored on the Verlag, so it is only editable while
                     creating one; for an existing Verlag it is shown read-only. -->
                <FormField
                    v-if="form._publisherCreateNew"
                    v-model="form._publisherLocation"
                    label="Erscheinungsort"
                    tooltip="publisherLocation"
                    placeholder="Erscheinungsort eingeben"
                    :highlight="true"
                />
                <FormField
                    v-else
                    :model-value="selectedPublisherLocation"
                    label="Erscheinungsort"
                    tooltip="publisherLocation"
                    :readonly="true"
                />
            </div>
        </div>

        <FormField
            v-model="form.isbn"
            label="ISBN"
            tooltip="isbn"
            placeholder="ISBN eingeben"
            :recommended="true"
        >
            <template #after>
                <SimilarTitles
                    v-if="isNew"
                    :value="form.isbn"
                    :check-url="checkIsbnUrl"
                    :confirm-modal="confirmModal"
                    header="Es gibt Artikel mit gleicher ISBN:"
                />
            </template>
        </FormField>
    </FormBox>
</template>

<script setup>
import {computed} from 'vue';
import FormBox from './FormBox.vue';
import FormField from './FormField.vue';
import FormSelect from './FormSelect.vue';
import SimilarTitles from './SimilarTitles.vue';
import {PublicationType} from '../publicationTypes';

const props = defineProps({
    form: { type: Object, required: true },
    currentType: { type: [Number, String], required: true },
    payload: { type: Object, required: true },
    checkIsbnUrl: { type: String, default: '' },
    isNew: { type: Boolean, default: false },
    confirmModal: { type: Object, default: null },
});

/** Erscheinungsort of the selected Verlag — display only, it belongs to the publisher record. */
const selectedPublisherLocation = computed(() => {
    const uid = props.form.publisher;
    if (uid == null || uid === '') return '';
    const publisher = props.payload.publishers.find(p => p.uid == uid);
    return publisher?.location ?? '';
});

function startCreate() {
    props.form._publisherCreateNew = true;
    props.form._publisherName = '';
    props.form._publisherLocation = '';
    props.form.publisher = null;
}

function cancelCreate() {
    props.form._publisherCreateNew = false;
    props.form._publisherName = '';
    props.form._publisherLocation = '';
}
</script>
